$('.dev_customBtn').on('click', function(e){
  e.preventDefault();
  $('.dev_photoPopup').css('display', 'block');
  $('.dev_popupOverlay').css('display', 'block');
  $('body').addClass('dev_popupShow');
});

$('.dev_requestQuote').on('click', function(e){
  e.preventDefault();
  $('.dev_photoPopup').css('display', 'block');
  $('.dev_popupOverlay').css('display', 'block');
  $('body').addClass('dev_popupShow');
});

$('.dev_close').on('click', function(){
  $('.dev_photoPopup').css('display', 'none');
  $('.dev_popupOverlay').css('display', 'none');
  $('body').removeClass('dev_popupShow');
});

$('.dev_popupOverlay').on('click', function(event){
  if(event.target.id=="dev_outerOverlay"){
    $('.dev_photoPopup').css('display', 'none');
    $(this).css('display', 'none');
    $('body').removeClass('dev_popupShow');
  }

});

